<template>
  <TabbedPortletHead class="mx-2 mb-4 sourceTypeNavigation">
    <li
      class="nav-item"
      v-for="(sourcetype, index) in sourceTypes" :key="sourcetype.value">
      <a
        href=""
        class="nav-link select-none"
        :class="{ 'active': (!itinerarySourceTypeSelected.value && index === 0) || isSourceTypeActive(sourcetype.value) }"
        @click.prevent="selectTab(sourcetype)">
        {{ (index === 0 && isTrafalgarRiver) ? 'Cruise' : sourcetype.label }}
        <!--<span
          class="kt-badge kt-badge--beta kt-badge--inline kt-badge--pill kt-badge--rounded ml-3"
          v-tooltip.right-end="{ content: 'Software in the beta phase will generally have many more bugs in it than completed software, speed or performance issues, and may still cause crashes or data loss. Please not use for commercial purpose.', offset: 5 }"
          v-if="index > 0">Beta
        </span>-->
      </a>
    </li>
  </TabbedPortletHead>
</template>

<script>
import TabbedPortletHead from '@/components/_shared/tabbed-portlet/TabbedPortletHead.vue'
import {OPPORTUNITY__BRANDS} from "@/constants";
import {mapGetters} from "vuex";

export default {
  name: 'SourceTypeNavigation',
  components: {
    TabbedPortletHead
  },
  props: {
    sourceTypes: {
      type: Array,
      required: true
    },
    itinerarySourceTypeSelected: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      'opportunityData': 'opportunity/opportunity',
    }),
    isTrafalgarRiver() {
      return (
        this.opportunityData &&
        OPPORTUNITY__BRANDS.TRAFALGAR_RIVER === this.opportunityData.properties_opportunity.id_brand
      );
    },
  },
  methods: {
    isSourceTypeActive (value) {
      return this.itinerarySourceTypeSelected.value === value
    },
    selectTab (sourceType) {
      this.$emit('onSelectTab', sourceType)
    }
  }
}
</script>

<style lang="scss" scoped>
.kt-badge--beta {
  background-color: #989898 !important;
  color: white;
}
</style>
